import { handleActions } from 'redux-actions'
import { setLocalItem, getLocalItem } from '../../utils'
import { AppModel } from '../../model/app.model'
import { Set_App_Info } from '../actions/app'

const Local_App_Key = 'L_APP_INFO'

/** 用户信息初始化 */
const initAppInfo = (): AppModel | null => {
    return getLocalItem(Local_App_Key)
}

const appReducer = handleActions(
    {
        /** 存储用户信息 */
        [Set_App_Info]: (state, { payload }) => {
            if (!payload) return null
            setLocalItem(Local_App_Key, payload)
            return payload
        },
    },
    initAppInfo()
)

export default appReducer
